import { Component } from '@angular/core';

@Component({
  selector: 'app-utility-deduction',
  templateUrl: './utility-deduction.component.html',
  styleUrls: ['./utility-deduction.component.css']
})
export class UtilityDeductionComponent {

}
